export default "__VITE_ASSET__b6c086ab__"